function formatPhone(phone) {
  if (phone && phone.length === 11 && phone[0] === "3" && phone[1] === "3") {
    return (`0${phone.substring(2)}`.replace(/(.{2})/g,"$1 "))
  }
  return phone
}

export default formatPhone
